import { Prelevement } from "../Shared/prelevement";
import { EImportance } from "./enum/importance";
import { ETypeSubstrat } from "./enum/type-substrat";
import { EZone } from "./enum/zone";

export class Substrat {
    Index: number;
    Zone: EZone;
    Type: ETypeSubstrat;
    Importance: EImportance;

    Prelevement: Prelevement

    static mapFromJSON(json): Substrat {
        const s = new Substrat();

        s.Zone = json.zone;
        s.Importance = json.importance;
        s.Type = json.type;

        if (json.prelevement)
            s.Prelevement = Prelevement.mapFromJSON(json.prelevement);

        return s;
    }
}